<template>
    <div>
        <code-box :link="$_c+'/Map/MapThreeLevel.vue'" class="com-line">
            <map-three-level></map-three-level>
        </code-box>
    </div>
</template>
<script>
import MapThreeLevel from '_c/Map/MapThreeLevel'
export default {
    components:{
        MapThreeLevel
    }
}
</script>
